import React from 'react';
import { motion } from 'framer-motion';
import { SectionLabel, SectionHeading } from './ui/UI';
const steps = [{
  n: '01',
  title: 'Connect',
  body: 'Cloud, identity, SaaS, code, domains, external exposure, AI applications, optional internal runner. Guided permissions, clear scope.'
}, {
  n: '02',
  title: 'Model',
  body: 'Periscan builds an AI-driven evidence model of your environment — assets, identities, permissions, code signals, AI applications, remediation history.'
}, {
  n: '03',
  title: 'Validate',
  body: 'Identify realistic paths to compromise. Validate which risks are reachable, exploitable, exposed, misconfigured, or blocked. Controlled and scoped.'
}, {
  n: '04',
  title: 'Prioritize',
  body: 'Rank what matters based on evidence, reachability, privilege, impact, confidence, exploitability, business context, and validation status.'
}, {
  n: '05',
  title: 'Fix',
  body: 'Plain-English remediation, technical steps, owner guidance, ticket-ready action plans.'
}, {
  n: '06',
  title: 'Verify',
  body: 'Re-test the path. Confirm whether the risk is fixed, partially fixed, still exposed, mitigated, inconclusive, or reopened due to drift.'
}, {
  n: '07',
  title: 'Prove',
  body: 'Evidence-backed reports your team can share with customers, auditors, cyber insurers, executives, boards, vCISOs, and MSSP clients.'
}];
export function Workflow() {
  return <section id="workflow" className="relative w-full py-32 border-t border-white/5" data-id="element-905">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-906">
        <SectionLabel number="07" label="How It Works" className="mb-8" data-id="element-907" />

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-16" data-id="element-908">
          <div className="lg:col-span-8" data-id="element-909">
            <SectionHeading size="xl" data-id="element-910">
              From signal to proof
              <br data-id="element-911" />
              <span className="text-white/40" data-id="element-912">in seven steps.</span>
            </SectionHeading>
          </div>
        </div>

        {/* Workflow grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-7 gap-px bg-white/5 rounded-2xl overflow-hidden border border-white/5" data-id="element-913">
          {steps.map((step, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: i * 0.06
        }} className="bg-[#070a0e] p-6 lg:p-5 hover:bg-[#0a0d12] transition-colors min-h-[260px] flex flex-col" data-id="element-914">
              <span className="font-mono text-xs text-[#1a8fd4]/60 mb-6" data-id="element-915">
                {step.n}
              </span>
              <h3 className="text-2xl font-semibold text-white mb-3 tracking-tight" data-id="element-916">
                {step.title}
              </h3>
              <p className="text-sm text-white/50 leading-relaxed" data-id="element-917">
                {step.body}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}